<template>
  <div v-if="allErrorMessages.length">
    <VaAlert
      v-for="(error, idx) in allErrorMessages"
      :key="idx"
      color="danger"
      closeable
      @update:modelValue="(e) => handleChange(idx)"
    >
      {{ error }}
    </VaAlert>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useToast } from 'vuestic-ui'

import { useErrorStore } from '@/stores/error.store'
import { useCountryCachedStore } from '@/stores/country.store'
import { useApplicationStore } from '@/stores/application.store'
import { useRelationshipCachedStore } from '@/stores/relationship.store'
import { useCtvCachedStore } from '@/stores/ctv.store'

const { init: notify } = useToast()

const countryStore = useCountryCachedStore()
const { error: countriesLoadingError, message: countryLoadingErrorMessage } = storeToRefs(countryStore)

const applicationStore = useApplicationStore()
const { error: applicationLoadingError, message: applicationLoadingErrorMessage } = storeToRefs(applicationStore)

const relationshipStore = useRelationshipCachedStore()
const { error: relationshipLoadingError, message: relationshipLoadingErrorMessage } = storeToRefs(relationshipStore)

const ctvStore = useCtvCachedStore()
const { error: ctvLoadingError, message: ctvLoadingErrorMessage } = storeToRefs(ctvStore)

const errorStore = useErrorStore()
const { errors } = storeToRefs(errorStore)

const allErrorMessages = ref(
  [
    ...errors.value,
    countriesLoadingError.value ? countryLoadingErrorMessage.value : null,
    relationshipLoadingError.value ? relationshipLoadingErrorMessage.value : null,
    applicationLoadingError.value ? applicationLoadingErrorMessage.value : null,
    ctvLoadingError.value ? ctvLoadingErrorMessage.value : null,
  ].filter(Boolean),
)

allErrorMessages.value.forEach((err) => {
  notify({ message: err, color: 'danger', position: 'bottom-right' })
})

const handleChange = (idx) => allErrorMessages.value.splice(idx, 1)
</script>
